import { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import api from '@/services/api';
import ScoreboardBoard from '@/components/scoreboard/ScoreboardBoard';
import { normalizeState, scoreboardChannel, type ScoreboardMatch, type ScoreboardState } from '@/components/scoreboard/engine';
import { usePageDocumentTitle } from '@/contexts/PageDocumentTitleContext';

export default function ScoreboardDisplayPage() {
  const { id } = useParams<{ id: string }>();
  const [state, setState] = useState<ScoreboardState | null>(null);
  const [now, setNow] = useState(() => Date.now());
  const [error, setError] = useState<string | null>(null);

  usePageDocumentTitle(state?.eventName || '比分顯示');

  useEffect(() => {
    if (!id) return;
    const load = () => {
      api
        .get<{ match: ScoreboardMatch }>(`/scoreboards/${id}`)
        .then((res) => setState(normalizeState(res.data.match.state)))
        .catch(() => setError('找不到比分牌'));
    };
    load();
    const poll = window.setInterval(load, 2000);
    const channel = new BroadcastChannel(scoreboardChannel(id));
    channel.onmessage = (event) => {
      if (event.data) setState(normalizeState(event.data as ScoreboardState));
    };
    return () => {
      window.clearInterval(poll);
      channel.close();
    };
  }, [id]);

  useEffect(() => {
    const timer = window.setInterval(() => setNow(Date.now()), 250);
    return () => window.clearInterval(timer);
  }, []);

  if (!state) {
    return (
      <Box sx={{ minHeight: '100vh', bgcolor: '#070b10', color: '#fff', display: 'grid', placeItems: 'center' }}>
        <Typography>{error || '載入顯示畫面…'}</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ height: '100vh', width: '100vw', overflow: 'hidden', bgcolor: '#05070b' }}>
      <ScoreboardBoard state={state} now={now} />
    </Box>
  );
}
